import { ParentTree } from '@holmescorp/lcc-interfaces';
import { orderBy } from 'natural-orderby';

import { userstore } from '../base';
import { TrackedState } from '../interfaces';
import { statusChange } from '../UserState';

export function rollupStatus(key: string, newvals: TrackedState): void {
	const { get, path } = userstore;
	const status = get(path('status'));
	const item = status[key];
	const { data } = item;
	const { complete: oldcomplete, pointscorrect: oldpointscorrect, pointsincorrect: oldpointsincorrect } = data;
	const {
		complete: newcomplete,
		pointscorrect: newpointscorrect,
		pointsincorrect: newpointsincorrect,
		percent: newpercent
	} = newvals;

	let deltaComplete = 0;
	if (oldcomplete !== newcomplete) {
		deltaComplete = newcomplete - oldcomplete;
		data.complete = newcomplete;
	}
	let deltaPointscorrect = 0;
	let deltaPointsincorrect = 0;
	if (oldpointscorrect !== newpointscorrect || oldpointsincorrect !== newpointsincorrect) {
		deltaPointscorrect = newpointscorrect - oldpointscorrect;
		deltaPointsincorrect = newpointsincorrect - oldpointsincorrect;
		data.pointscorrect = newpointscorrect;
		data.pointsincorrect = newpointsincorrect;
		data.percent = newpercent;
	}

	let parent = item.parent;
	while (parent !== null) {
		const prev = status[parent];
		prev.data.complete += deltaComplete;
		prev.data.pointscorrect += deltaPointscorrect;
		prev.data.pointsincorrect += deltaPointsincorrect;
		const totalpoints = prev.data.pointscorrect + prev.data.pointsincorrect;
		if (totalpoints > 0) {
			prev.data.percent = prev.data.pointscorrect / totalpoints;
		} else {
			prev.data.percent = 0;
		}
		parent = prev.parent;
	}

	statusChange({ status });
}

const is_Topicset = (key: string | null, status: ParentTree): boolean => {
	if (key === null) {
		return false;
	}
	const { parent } = status[key];
	if (parent) {
		return !parent.startsWith('topic');
	}
	return false;
};

const is_Topicgroup = (key: string | null, status: ParentTree): boolean => {
	if (key === null) {
		return false;
	}
	const { parent } = status[key];
	return is_Topicset(parent, status);
};

export function setPrevNext(): void {
	const { get, path } = userstore;
	const status = get(path('status'));
	const keys = orderBy(Object.keys(status));
	let changed = false;
	let currentTopic: string | null = null;
	keys.forEach((key) => {
		if (key.startsWith('topic')) {
			const isTopicset = is_Topicset(key, status);
			const isTopicgroup = is_Topicgroup(key, status);

			if (isTopicset) {
				if (status[key].next !== null) {
					status[key].next = null;
					changed = true;
				}
			} else if (isTopicgroup) {
				if (currentTopic !== null && status[currentTopic].next !== null) {
					status[currentTopic].next = null;
					changed = true;
				}
				currentTopic = null;
			} else {
				if (status[key].previous !== currentTopic) {
					status[key].previous = currentTopic;
					changed = true;
				}
				if (currentTopic !== null && status[currentTopic].next !== key) {
					status[currentTopic].next = key;
					changed = true;
				}
				currentTopic = key;
			}
		}
	});

	if (changed) {
		statusChange({ status });
	}
}
